import { Component, Input } from '@angular/core';

/**
 * NOTICE: This component is used throughout the application.
 * If changing, ensure it remains reusable and does not break existing usage.
 * For specific customizations, add an appropriate parameter.
 */
@Component({
  selector: 'app-loading-panel',
  templateUrl: './loading-panel.component.html',
  styleUrls: ['./loading-panel.component.scss'],
})
export class LoadingPanelComponent {
  @Input() showLoading = false;
  @Input() overlay = false;
  @Input() hideText = false;
  @Input() isSmall = false;
  @Input() variant: 'overlay' | 'inline' | 'default' | 'freeze' = 'default';
}
